import Component from "../../../lib/component";

export const BackdropConfig = {
    componentTypeKey: 'Backdrop',
    baseHtmlClass: 'nav_menu_backdrop',
    selector: '.nav_menu_backdrop',
};

export class Backdrop extends Component {

    static createBackdrop(navMenu) {
        const element = document.createElement('div');
        element.classList.add(Backdrop.config.baseHtmlClass);
        element.style.display = 'none'; // Ensure it's hidden until we want to show it for the first time.
        document.body.append(element);
        return new Backdrop(element, navMenu);
    }
    static get config() {
        return BackdropConfig;
    }

    constructor(id_or_element, navMenu) {
        super({
            element: id_or_element,
            config: Backdrop.config
        });

        this.navMenu = navMenu;
    }

    showBackdrop() {
        this.element.style.display = null;
        this.element.addEventListener('click', this.handleClick.bind(this));
        this.addHtmlClassState('visible');
    }

    hideBackdrop() {
        this.element.removeEventListener('click', this.handleClick.bind(this));
        this.removeHtmlClassState('visible');
    }

    handleClick(event) {
        event.preventDefault();
        this.navMenu.close();
    }

    render() {
        this.isOpen() ? this.showBackdrop() : this.hideBackdrop();
    }

    isOpen() {
        return this.navMenu.isOpen();
    }

}